@import "../use-bootstrap-mixins.scss";

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.container {
  max-width: 1200px;
  background-color: #f5f5f5;
  margin: 0 auto;
  padding: 20px;
  border-radius: 12px;

  .fold {
    width: 100%;

    border-bottom: 2px dashed #333;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
      flex: 1;
    }

    button {
      width: 166px !important;

      @include media-breakpoint-down(lg) {
        display: none;
      }
    }

    .title {
      display: block;
      font-size: 18px;
      margin-bottom: 12px !important;
      text-align: center !important;

      @include media-breakpoint-up(lg) {
        font-size: 33px;
      }
    }
  }

  .copy {
    font-size: 10px;
    display: block;
    line-height: normal;
    padding: 8px 0;

    @include media-breakpoint-up(lg) {
      font-size: 14px;
    }
  }

  .payment_container {
    margin-top: 38px;

    .header {
      color: $primaryOnBackground !important;
    }

    .error_label {
      font-size: 12px;
      color: red !important;
      font-style: italic;
    }
  }

  .confirmation {
    padding-bottom: 24px;

    .error {
      margin: 0 auto;
      max-width: 500px;
      padding-top: 12px;
      span {
        display: block;
        text-align: center !important;
      }
    }

    .success {
      .top_container {
        max-width: min-content;
        margin: 0 auto;

        .orderNumber {
          font-size: 10px !important;
          text-align: left !important;
        }

        .waitingNum {
          text-align: center !important;
          text-decoration: underline;
          font-size: 36px !important;
          font-weight: 600 !important;
          line-height: 34px !important;
        }
      }

      .confirmation_text {
        max-width: 450px !important;
        display: block;
        margin: 0 auto;
        font-size: 14px !important;
        font-weight: 400 !important;
        text-align: center !important;
        padding-top: 12px !important;
      }
    }
  }

  .error_page {
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .header {
      font-size: 33px !important;
      font-weight: 400 !important;
      margin-bottom: 68px !important;
    }

    .p {
      font-size: 20px !important;
      font-weight: 700 !important;
    }

    .p1 {
      max-width: 450px;
      font-size: 14px;
    }

    button {
      max-width: 166px;
    }
  }

  .payViaGateway {
    max-width: 200px;
  }
}
